// extracted by mini-css-extract-plugin
var _1 = "btn-oIFoy";
var _2 = "cash-Te2Vc";
var _3 = "close-Xf6lg";
var _4 = "coupon-IsNic";
var _5 = "down-_gIlY";
var _6 = "gift-UlH4Z";
var _7 = "offer-P1KxE";
var _8 = "open-wOUjF";
var _9 = "toggle-aViZP";
var _a = "up-DFPF8";
export { _1 as "btn", _2 as "cash", _3 as "close", _4 as "coupon", _5 as "down", _6 as "gift", _7 as "offer", _8 as "open", _9 as "toggle", _a as "up" }
